import { render, staticRenderFns } from "./AssociatedDrivers.vue?vue&type=template&id=5ed8b015&scoped=true&"
import script from "./AssociatedDrivers.vue?vue&type=script&lang=js&"
export * from "./AssociatedDrivers.vue?vue&type=script&lang=js&"
import style0 from "./AssociatedDrivers.vue?vue&type=style&index=0&id=5ed8b015&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed8b015",
  null
  
)

export default component.exports